import * as React from 'react';
import { inject, observer } from 'mobx-react';

// Utilities
import { ifNot } from '../../utilities/error';

// Types
import { Router, Params as IParams, NavigationOptions as INavigationOptions } from 'router5';
import { IStore } from '../../store/Store';
import { IRouterStore } from '../../store/RouterStore';

// Component
interface IProps {
    store?: IStore;

    router?: Router;

    routeName: string;
    routeParams?: IParams;
    routeOptions?: INavigationOptions;

    dangerouslySetInnerHTML?: string;
    className?: string;
    style?: React.CSSProperties;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

class Link extends React.Component<IProps> {

    routerStore: IRouterStore;
    router: Router;

    constructor(props: IProps) {
        super(props);

        // Get the router instance from the props (when explicitly passed) or from routerStore
        // It is passed to props for example when using withRoute wrapper
        this.routerStore = props.store!.routerStore;
        if (this.routerStore) {
            this.router = this.routerStore.router;
        } else {
            this.router = props.router!;
        }

        ifNot(
            !props.routeName || !!this.router,
            '[Link] missing router instance'
        );

        ifNot(
            !this.router || !props.routeName || this.router.hasPlugin('BROWSER_PLUGIN'),
            '[Link] missing browser plugin, href might build incorrectly'
        );

        // Bindings
        this.clickHandler = this.clickHandler.bind(this);
    }

    buildUrl(routeName: string, routeParams: object) {
        let url = '#';
        if (routeName && this.router) {
            // If browser plugin is active
            // if (this.router.buildUrl) {
            //     url = this.router.buildUrl(routeName, routeParams);
            // } else {
            url = this.router.buildPath(routeName, routeParams);
            ifNot(
                url !== null,
                '[Link] Could not build path with given route props.'
            );
            // }
        }
        return url;
    }

    clickHandler(e: React.MouseEvent<HTMLAnchorElement>) {
        // If props onClick is passed it will be executed
        // instead of navigating to the route
        if (this.props.onClick) {
            this.props.onClick(e);
            if (e.defaultPrevented) {
                return;
            }
        }

        const comboKey = e.metaKey || e.altKey || e.ctrlKey || e.shiftKey;

        if (e.button === 0 && !comboKey) {
            e.preventDefault();
            this.router.navigate(this.props.routeName, this.props.routeParams || {}, this.props.routeOptions || {});
        }
    }

    render() {
        const { routeName, routeParams, className, dangerouslySetInnerHTML, style } = this.props;
        const href = this.buildUrl(routeName, routeParams || {});
        const onClick = this.clickHandler;
        const newProps = { href: href, className: className, onClick: onClick, style };
        if (dangerouslySetInnerHTML) {
            const dangerouslySetInnerHTMLKey = 'dangerouslySetInnerHTML';
            newProps[dangerouslySetInnerHTMLKey] = dangerouslySetInnerHTML;
        }
        return React.createElement('a', newProps, this.props.children);
    }
}

// Exports
export default inject('store')(observer(Link));


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Link/Link.tsx